import { createContext } from 'react';

export const StateContext = <T extends unknown>(arr) => createContext<[T, Function]>(arr);

export default StateContext;
